/** Money pages only the principal (studio manager) may open, on any device. */
export const PAYMENTS_ONLY_PRINCIPAL = new Set(["valuations", "expenses", "cost", "cashflow"]);
